$(function() {
  'use strict';
  /**
   * 地図の初期化
   */
  function initMap() {
    var latlng = new google.maps.LatLng(35.688718, 139.709294);
    var mapOptions = {
      zoom: 18,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      center: new google.maps.LatLng(35.688718, 139.709294),
      scrollwheel: false,
      draggable: false,
      mapTypeControl: false,
      disableDoubleClickZoom: true,
      noClear: true
    };
    var map = new google.maps.Map(document.getElementById('gmap'), mapOptions);
    var marker = new google.maps.Marker({
      position: latlng,
      map: map
    });
  }
  // イメージの遅延ロード
  $('.lazy_loader').each(function() {
    var $element = $(this);
    var $figure = $element.parent();
    var $lazyImg = $('<img src="' + $element.data('normal') + '"/>');
    $lazyImg.hide();
    $lazyImg.bind('load', function() {
      $figure.append($lazyImg);
      $element.remove();
      $lazyImg.show();
    });
  });
  // 地図の表示
  if ($('#gmap').length > 0) {
    initMap();
  }
  // 高さ揃え
  $('.relate .post-link').tile(5);
  $('.article__index .post-link').tile(3);
});

//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiIiwic291cmNlcyI6WyJjb21tb24uanMiXSwic291cmNlc0NvbnRlbnQiOlsiJChmdW5jdGlvbigpIHtcbiAgJ3VzZSBzdHJpY3QnO1xuICAvKipcbiAgICog5Zyw5Zuz44Gu5Yid5pyf5YyWXG4gICAqL1xuICBmdW5jdGlvbiBpbml0TWFwKCkge1xuICAgIHZhciBsYXRsbmcgPSBuZXcgZ29vZ2xlLm1hcHMuTGF0TG5nKDM1LjY4ODcxOCwgMTM5LjcwOTI5NCk7XG4gICAgdmFyIG1hcE9wdGlvbnMgPSB7XG4gICAgICB6b29tOiAxOCxcbiAgICAgIG1hcFR5cGVJZDogZ29vZ2xlLm1hcHMuTWFwVHlwZUlkLlJPQURNQVAsXG4gICAgICBjZW50ZXI6IG5ldyBnb29nbGUubWFwcy5MYXRMbmcoMzUuNjg4NzE4LCAxMzkuNzA5Mjk0KSxcbiAgICAgIHNjcm9sbHdoZWVsOiBmYWxzZSxcbiAgICAgIGRyYWdnYWJsZTogZmFsc2UsXG4gICAgICBtYXBUeXBlQ29udHJvbDogZmFsc2UsXG4gICAgICBkaXNhYmxlRG91YmxlQ2xpY2tab29tOiB0cnVlLFxuICAgICAgbm9DbGVhcjogdHJ1ZVxuICAgIH07XG4gICAgdmFyIG1hcCA9IG5ldyBnb29nbGUubWFwcy5NYXAoZG9jdW1lbnQuZ2V0RWxlbWVudEJ5SWQoJ2dtYXAnKSwgbWFwT3B0aW9ucyk7XG4gICAgdmFyIG1hcmtlciA9IG5ldyBnb29nbGUubWFwcy5NYXJrZXIoe1xuICAgICAgcG9zaXRpb246IGxhdGxuZyxcbiAgICAgIG1hcDogbWFwXG4gICAgfSk7XG4gIH1cbiAgLy8g44Kk44Oh44O844K444Gu6YGF5bu244Ot44O844OJXG4gICQoJy5sYXp5X2xvYWRlcicpLmVhY2goZnVuY3Rpb24oKSB7XG4gICAgdmFyICRlbGVtZW50ID0gJCh0aGlzKTtcbiAgICB2YXIgJGZpZ3VyZSA9ICRlbGVtZW50LnBhcmVudCgpO1xuICAgIHZhciAkbGF6eUltZyA9ICQoJzxpbWcgc3JjPVwiJyArICRlbGVtZW50LmRhdGEoJ25vcm1hbCcpICsgJ1wiLz4nKTtcbiAgICAkbGF6eUltZy5oaWRlKCk7XG4gICAgJGxhenlJbWcuYmluZCgnbG9hZCcsIGZ1bmN0aW9uKCkge1xuICAgICAgJGZpZ3VyZS5hcHBlbmQoJGxhenlJbWcpO1xuICAgICAgJGVsZW1lbnQucmVtb3ZlKCk7XG4gICAgICAkbGF6eUltZy5zaG93KCk7XG4gICAgfSk7XG4gIH0pO1xuICAvLyDlnLDlm7Pjga7ooajnpLpcbiAgaWYgKCQoJyNnbWFwJykubGVuZ3RoID4gMCkge1xuICAgIGluaXRNYXAoKTtcbiAgfVxuICAvLyDpq5jjgZXmj4PjgYhcbiAgJCgnLnJlbGF0ZSAucG9zdC1saW5rJykudGlsZSg1KTtcbiAgJCgnLmFydGljbGVfX2luZGV4IC5wb3N0LWxpbmsnKS50aWxlKDMpO1xufSk7XG4iXSwiZmlsZSI6ImNvbW1vbi5qcyJ9
